import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export const AppConfig = {
  site_name: 'cleartax',
  title: 'Cleartax Website',
  description: 'Cleartax Website',
  locale: 'en',
  GTM_TAG: publicRuntimeConfig.BASE_URL.GTM_TAG,
  GA4_TAG: publicRuntimeConfig.BASE_URL.GA4_TAG,
  GTM_CONVERSION_ID: 'AW-948914955/OySWCPHX_c8bEIuWvcQD',
};
